import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationMasterStateService {
  private smsConfigmasters$ = new Map<number, any[]>();
  smsConfigmasters = this.smsConfigmasters$;

  private whatsappConfigmasters$ = new Map<number, any[]>();
  whatsappConfigmasters = this.whatsappConfigmasters$;

  private emailConfigmasters$ = new Map<number, any[]>();
  emailConfigmasters = this.emailConfigmasters$;

  private smsTemplateMasters$ = new Map<number, any[]>();
  smsTemplateMasters = this.smsTemplateMasters$;

  private emailTemplateMasters$ = new Map<number, any[]>();
  emailTemplateMasters = this.emailTemplateMasters$;

  private whatsappTemplateMasters$ = new Map<number, any[]>();
  whatsappTemplateMasters = this.whatsappTemplateMasters$;

  private emailFromMasters$ = new Map<number, any[]>();
  emailFromMasters = this.emailFromMasters$;

  setSmsConfigMasters(tenantId: number, smsConfigMasters: any[]) {
    this.smsConfigmasters$.set(tenantId, smsConfigMasters);
  }

  getSmsConfigMasters(tenantId: number) {
    return this.smsConfigmasters$.get(tenantId);
  }

  setWhatsappConfigMasters(tenantId: number, whatsappConfigMasters: any[]) {
    this.whatsappConfigmasters$.set(tenantId, whatsappConfigMasters);
  }

  getWhatsappConfigMasters(tenantId: number) {
    return this.whatsappConfigmasters$.get(tenantId);
  }

  setEmailConfigMasters(tenantId: number, emailConfigMasters: any[]) {
    this.emailConfigmasters$.set(tenantId, emailConfigMasters);
  }

  getEmailConfigMasters(tenantId: number) {
    return this.emailConfigmasters$.get(tenantId);
  }

  setSmsTemplateMasters(tenantId: number, smsTemplateMasters: any[]) {
    this.smsTemplateMasters$.set(tenantId, smsTemplateMasters);
  }

  getSmsTemplateMasters(tenantId: number) {
    return this.smsTemplateMasters$.get(tenantId);
  }

  setEmailTemplateMasters(tenantId: number, emailTemplateMasters: any[]) {
    this.emailTemplateMasters$.set(tenantId, emailTemplateMasters);
  }

  getEmailTemplateMasters(tenantId: number) {
    return this.emailTemplateMasters$.get(tenantId);
  }

  setWhatsappTemplateMasters(tenantId: number, whatsappTemplateMasters: any[]) {
    this.whatsappTemplateMasters$.set(tenantId, whatsappTemplateMasters);
  }

  getWhatsappTemplateMasters(tenantId: number) {
    return this.whatsappTemplateMasters$.get(tenantId);
  }
}
